exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckBox-module__wrapper___t-SZ2{display:flex;align-items:center;gap:12px;cursor:pointer}.CheckBox-module__wrapper___t-SZ2.CheckBox-module__blueGray___20hrz .CheckBox-module__checkbox___3JcqN{background-color:#e8f7fc}.CheckBox-module__wrapper___t-SZ2 .CheckBox-module__checkbox___3JcqN{width:22px;height:22px;background-color:#fff;border-radius:6px;display:flex;justify-content:center;align-items:center;cursor:pointer}.CheckBox-module__wrapper___t-SZ2 .CheckBox-module__checkbox___3JcqN svg{transition:.25s}", ""]);

// exports
exports.locals = {
	"wrapper": "CheckBox-module__wrapper___t-SZ2",
	"blueGray": "CheckBox-module__blueGray___20hrz",
	"checkbox": "CheckBox-module__checkbox___3JcqN"
};